import React, { PureComponent } from 'react'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPlus,
  faTimes,
  faTimesCircle,
  faChartLine,
  faCompressArrowsAlt,
  faStar,
  faChartBar,
  faSearchDollar,
  faUser,
  faUsers,
  faFolderOpen,
  faChevronUp,
  faChevronDown,
  faHandHoldingUsd,
  faDumbbell
} from '@fortawesome/free-solid-svg-icons'

import './AppBarNoAccess.css'

library.add(
  faPlus,
  faTimes,
  faTimesCircle,
  faChartLine,
  faCompressArrowsAlt,
  faStar,
  faChartBar,
  faSearchDollar,
  faUser,
  faUsers,
  faFolderOpen,
  faChevronUp,
  faChevronDown,
  faHandHoldingUsd,
  faDumbbell
)

class AppBarNoAccess extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showPrivate: false
    }
  }

  getIcon(name) {
    switch (name) {
      case 'my-portfolio-hub':
        return 'PieLeftSlice.svg'
      case 'portfolio-analysis':
        return 'ChartCombo.svg'
      case 'custom-models':
        return 'PieRightSlice.svg'
      case 'fund-comparison':
        return 'PieRightSlice.svg'
      case 'capital-gains-comparison':
        return 'Speedometer.svg'
      case 'morningstar-ratings':
        return 'Sunshine.svg'
      case 'fibb':
        return 'Barbell.svg'
      case 'performance-at-a-glance':
        return 'DoubleLineChart.svg'
      case 'index-attribution':
        return 'BarChart.svg'
      case 'fund-attribution':
        return 'BarChart.svg'
      case 'yield':
        return 'ArrowRight.svg'
      case 'models':
        return 'ArrowRight.svg'
      case 'dashboard':
        return 'ArrowRight.svg'
      case 'befi':
        return 'ArrowRight.svg'
      case 'taxport':
        return 'ArrowRight.svg'
      case 'earnings':
        return 'Money.svg'
      default:
        return ''
    }
  }

  mouseOn() {
    this.setState({
      showPrivate: true
    })
  }

  mouseOff() {
    this.setState({
      showPrivate: false
    })
  }

  render() {
    const { title, description, name, divId, activeApp, link, message, placement } =
      this.props

    const { showPrivate } = this.state

    let appStyle = 'naBarStyle'
    let columnClass = 'col-md-4'
    let iconHolderStyle = 'iconHolderStyle'
    let titleStyle = 'titleStyle'
    let aniStyle = 'aniStyle'
    let closeStyle = 'closeStyle'
    let iconStyle = 'iconStyle'

    const renderIcon = () => {
      const iconPath = `${process.env.REACT_APP_BASE_URL}icons${this.state.showPrivate
          ? this.props.placement === 'moreResources'
            ? 'Off'
            : 'On'
          : this.props.placement === 'moreResources'
            ? 'On'
            : 'Off'
        }/${this.getIcon(name)}`

      return (
        <div className={iconHolderStyle}>
          <img className={iconStyle} src={iconPath} />
        </div>
      )
    }

    return (
      <div className={columnClass + ' ' + aniStyle}>
        {showPrivate && (
          <div className={'naInfo'} onMouseLeave={() => this.mouseOff()}>
            {activeApp === name && <div className={closeStyle}>&nbsp;</div>}
            {renderIcon()}
            <div className={titleStyle}>{message}</div>
            {activeApp !== name && (
              <div className={'descriptionStyle'}>
                <a href={`/sign-in?redirect=${link}`}>Sign In</a>
                <a href={`/registration/my-profile?redirect=${link}`}>Register</a>
              </div>
            )}
          </div>
        )}
        {!showPrivate && (
          <div className={appStyle} onMouseEnter={() => this.mouseOn()}>
            {activeApp === name && <div className={closeStyle}>&nbsp;</div>}
            {renderIcon()}
            <div className={titleStyle}>{title}</div>
            {activeApp !== name && (
              <div className={'descriptionStyle'}>{description}</div>
            )}
          </div>
        )}
        <div className={'appOffStyle'} id={divId}></div>
      </div>
    )
  }
}

export default AppBarNoAccess



// WEBPACK FOOTER //
// ./src/components/App/AppBarNoAccess.js